module.exports = __webpack_public_path__ + "img/goTop.cd328f52.svg";